'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'
import qs from 'qs'

export default {
  createUsers (models) {
    return new Promise((resolve, reject) => {
      Axios.post('/1.0/users', {users: models})
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchCompanyUsers (params) {
    return new Promise((resolve, reject) => {
      Axios.get(`/1.0/company-users`, {
        params,
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      })
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchCompanyUsersDropdown (params) {
    return new Promise((resolve, reject) => {
      Axios.get(`/1.0/company-users-dropdown`, {
        params,
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      })
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  updateUsers (models) {
    return new Promise((resolve, reject) => {
      Axios.put('/1.0/users', {users: models})
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  deleteUsers (models) {
    return new Promise((resolve, reject) => {
      Axios.delete(`/1.0/users`, {data: {users: models}})
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  }
}
